<template>
  <div class="pinwall__post__edit">
    <b-field :label="$t('text.name')">
      <TextEditor :text="post.text" @update="textUpdated"></TextEditor>
    </b-field>
    <!-- <LinkInput :contentLinks="post.links" @change="linksChanged" /> -->
    <b-field :label="$t('pickColor.name')">
      <ColorPicker :color="post.style" @input="setColor"></ColorPicker>
    </b-field>
    <button
      type="submit"
      @click="$emit('save', post)"
      class="button is-success is-rounded action-button"
    >
      {{ $t("save.name") }}
    </button>
    <b-button
      @click="$emit('cancel')"
      icon-left="close"
      class="button is-danger is-rounded action-button cancel-button"
    >
      {{ $t("cancel") }}
    </b-button>
  </div>
</template>
<script>
import TextEditor from "../core/TextEditor";
// import LinkInput from "./LinkInput";
import ColorPicker from "../core/ColorPicker";

export default {
  name: "PostEdit",
  components: {
    TextEditor,
    // LinkInput,
    ColorPicker
  },
  props: {
    post: {
      type: Object
    }
  },
  methods: {
    textUpdated(value) {
      this.post.text = value;
    },
    setColor(color) {
      if (color === "#000000" || color === "#262626") {
        this.post.style = `background-color: ${color};color: #d3c9c9`;
      } else {
        this.post.style = `background-color: ${color}`;
      }
    },
    linksChanged(links) {
      this.post.links = [];
      links.map(link => {
        this.proportion =
          this.proportion == 0 || link.proportion < this.proportion
            ? link.proportion
            : this.proportion;
        if (link.url !== "") {
          const found = this.post.links.find(item => {
            return item.url === link.url;
          });
          if (!found) {
            this.post.links.push(link);
          }
        }
      });
    }
  }
};
</script>
